module.exports = __webpack_public_path__ + "img/image-loading.405554fb.svg";